/* eslint-disable react-hooks/exhaustive-deps */
import { JSX, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { IconSplay } from "@/components/icons";
import HeaderNavigation from "@/components/layout/Header/HeaderNavigation.tsx";

import { ROUTES } from "@/config/routes.ts";
import { cn } from "@/utils/cn";

import "./Header.css";
import HeaderSearchInput from "./HeaderSearchInput";
import MobileHeaderList from "./MobileHeaderList";

const Header = (): JSX.Element => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const [isSticky, setSticky] = useState(false);

  const [isSearchPage, setIsSearchPage] = useState<boolean>(pathname === ROUTES.SEARCH);

  useEffect(() => {
    pathname === ROUTES.SEARCH ? setIsSearchPage(true) : setIsSearchPage(false);
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > (isSearchPage ? 0 : 70));
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={cn(
        "fixed left-0 right-0 top-0 z-[40]  px-6 py-5 transition-all duration-300 max-2xl:px-5 max-sm:px-4 max-sm:py-3",
        {
          "bg-[var(--header)] backdrop-blur-[2rem]": isSticky,
        },
      )}
    >
      <div className="flex w-full flex-row items-center justify-between gap-[1.875rem]">
        <div className="flex items-center justify-center gap-2">
          <div className="hidden max-xl:block">
            <MobileHeaderList />
          </div>
          <Link to={ROUTES.MAIN.MAIN} title={t("navigation.to-home")} className="block">
            <IconSplay className={"relative block h-[3.125rem] fill-orange-1 max-lg:h-10 max-sm:max-w-[3.625rem]"} />
          </Link>
        </div>
        <div className={"flex w-full flex-row items-center justify-between xl:flex-1"}>
          <HeaderNavigation isSearchPage={isSearchPage} />
        </div>
      </div>
      {isSearchPage && (
        <div className="mb-5 mt-8 hidden max-sm:block">
          <HeaderSearchInput isSearchPage={isSearchPage} />
        </div>
      )}
    </header>
  );
};

export default Header;
